module.exports = __webpack_public_path__ + "ee70eef648f1ec49a929879e42a0d5ae.png";